import { useSelector } from 'react-redux';
import assets from 'assets';
import React, { useState, useEffect } from 'react';

import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import ClickAwayListener from 'react-click-away-listener';

// import { config } from '../../data/models';
import { Tooltip } from 'react-tooltip';
import theme from 'container/theme';

const ChatFilterMenu = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [selectedVal, setSelectedVal] = useState('Most recent');
  // const childMenuPanel = useRef(null);

  const model = useSelector(state => state.chat.model);

  const handleToggleMenu = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSelectValue = (val, name) => {
    setSelectedVal(name);
    dispatch.chat.setTimeFilter(val);
    setOpen(false);
  };

  useEffect(() => {
    setSelectedVal(model.label);
  }, [model]);

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Container onClick={handleToggleMenu}>
        <InputContainer>
          <span id='filter'>
            <input
              value={selectedVal}
              style={{ width: 'calc(100% - 20px)' }}
              readOnly
              type='text'
              name=''
              id=''
            />
          </span>
          <Tooltip
            anchorSelect='#filter'
            content='Filters'
            style={{ background: theme.colors.darkgrey }}
          />
          <img src={assets.chevronLeft} className='arrow' alt='' />
          {open && (
            <Menu>
              <div
                className='menu-item'
                onClick={() => handleSelectValue('', model.label)}
              >
                <p className='font-size-14'>Default</p>
              </div>
              <div
                className='menu-item'
                onClick={() => handleSelectValue('recent', 'Most recent')}
              >
                <p className='font-size-14'>Most recent</p>
              </div>
              <div
                className='menu-item'
                onClick={() => handleSelectValue('favourite', 'Favorites')}
              >
                <p className='font-size-14'>Favorites</p>
              </div>
            </Menu>
          )}
        </InputContainer>
      </Container>
    </ClickAwayListener>
  );
};

export default ChatFilterMenu;

const Container = styled.div`
  width: 150px;

  @media only screen and (max-width: 1200px) {
    width: 130px;
  }
  @media only screen and (max-width: 1100px) {
    width: 120px;
  }
  @media only screen and (max-width: 1055px) {
    width: 110px;
  }
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.darkgray};
  height: 40px;
  cursor: pointer;
  position: relative;
  padding: 0px 10px;
  color: ${({ theme }) => theme.colors.primary};
  border-radius: 7px;

  & input {
    flex-grow: 1;
    background-color: transparent;
    border: none;
    outline: none;
    height: 100%;
    color: ${({ theme }) => theme.colors.primary};
    font-size: 13px;
    cursor: pointer;
  }

  & .arrow {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%) rotate(-90deg);
  }

  @media only screen and (max-width: 420px) {
    max-width: 150px;
  }
`;

const Menu = styled.div`
  position: absolute;
  bottom: -5px;
  transform: translate(0%, 100%);
  width: 100%;
  right: 0px;

  width: 141px;

  & .menu-item {
    padding: 6px 13px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.darkgrey};
    background-color: ${({ theme }) => theme.colors.darkgray};
    cursor: pointer;
    & p {
      margin: 0px;
    }

    &:last-of-type {
      border-bottom: none;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    &:first-of-type {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }

    & .row-item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      & .menu-arrow {
        transform: rotate(-90deg);
      }
    }

    & .model-items {
      padding-inline: 0px;
    }

    & .modal-row {
      display: flex;
      align-items: center;
      gap: 5px;

      & img {
        width: 12px;
        height: 12px;
        object-fit: cover;
        border-radius: 4px;
      }
    }

    & .panel {
      /* display: none; */
      max-height: 0px;
      overflow: hidden;
      transition: max-height 0.2s ease-out;
    }
  }
`;
